import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { EmpleadoCrud } from "../../models/empleado";
import { EmpresasModel } from "src/app/pages/configuracion/maestros/empresas/models/empresas-model";
import { FiltroEmpleado } from "src/app/shared/models/filtros";
import { Observable, of } from "rxjs";
import { DatosEmpleadosService } from "./datos-empleados.service";
import { catchError, map } from "rxjs/operators";

export function validacionCodigo(empleados: EmpleadoCrud[], empleado: EmpleadoCrud): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {
    const value = control.value;
    if (value == '' || value == null) {
        return {codigoVacio: true};
    }else{
      let codigoExiste = empleados.findIndex(x => x.codigo.toUpperCase() == control.value.toUpperCase())

      if(codigoExiste > -1){
        let mismoNif = empleados.findIndex(x=> x.nif == empleado.nif)
        if(mismoNif > -1 && codigoExiste == mismoNif){
          return null
        }else{
          return {codigoExiste: true}
        }
      }else{
        return null
      }
    }
  }
}

export function formEmpleadoValidatorsOld(empleados: EmpleadoCrud[], empleado: EmpleadoCrud): ValidatorFn {
  return (form:AbstractControl) : ValidationErrors | null => {
      const nif = form.get('nif').value;
      const empresa = form.get('empresa').value;
      const _codigoEmpresa = empresa?.split('-')[0];
      const codigo = form.get('codigo').value;

      let nifExiste = empleados.findIndex(x => x.nif.toUpperCase() == nif?.toUpperCase());

      if(codigo==empleado.codigo && codigo!==''){
        if(nifExiste>-1 && nif!==empleado.nif){
          if(_codigoEmpresa==empleados[nifExiste].codigoEmpresa) return {empleadoExiste: true};
          else return null
        }else return null
      }else if(codigo == '' && nifExiste>-1){
        if(_codigoEmpresa==empleados[nifExiste].codigoEmpresa) return {empleadoExiste: true};
        else return null
      }else return null

    }
}

export function formEmpleadoValidators(datosEmpleadosService: DatosEmpleadosService, empleado: EmpleadoCrud): ValidatorFn { // Inject DatosEmpleadosService
  return (form: AbstractControl): Observable<ValidationErrors | null> => {
    const nif = form.get('nif').value;
    const empresa = form.get('empresa').value;
    const _codigoEmpresa = empresa?.split('-')[0];
    const codigo = form.get('codigo').value;

    if (!nif) {
      return of(null); // No NIF, no validation needed
    }

    // Create the filter for the NIF
    const filtroNif: FiltroEmpleado = {
      text: 'Nif',
      listaValores: [nif]
    };

    // Call the getEmpleados API
    return datosEmpleadosService.getEmpleados([filtroNif], 1).pipe(
      map((empleados: EmpleadoCrud[]) => {
        if (empleados && empleados.length > 0) {
          // NIF exists in the database
          // Check if it's the same employee being edited
          if (empleado && empleado.nif === nif && empleado.codigo === codigo) {
            return null; // It's the same employee, so it's valid
          } else {
            return { empleadoExiste: true }; // NIF is duplicated
          }
        } else {
          // NIF does not exist in the database
          return null;
        }
      }),
      catchError(() => {
        // Handle API error (e.g., network issue)
        return of(null); // Return null to not block the form
      })
    );
  };
}
export function formEmpleadoValidatorsWorking(datosEmpleadosService: DatosEmpleadosService, empleado: EmpleadoCrud): ValidatorFn { // Inject DatosEmpleadosService
  return (form: AbstractControl): Observable<ValidationErrors | null> => {
    const nif = form.get('nif').value;
    const empresa = form.get('empresa').value;
    const _codigoEmpresa = empresa?.split('-')[0];
    const codigo = form.get('codigo').value;

    if (!nif) {
      return of(null); // No NIF, no validation needed
    }

    // Create the filter for the NIF
    const filtroNif: FiltroEmpleado = {
      text: 'Nif',
      listaValores: [nif]
    };

    // Call the getEmpleados API
    return new Observable(observer => {

      datosEmpleadosService.getEmpleados([filtroNif], 1).subscribe(
        next => {
          if (next && next.length > 0) {
            // NIF exists in the database
            // Check if it's the same employee being edited
            if (empleado && empleado.nif === nif && empleado.codigo === codigo) {
              observer.next(null); // It's the same employee, so it's valid
            } else {
              observer.next({ empleadoExiste: true }); // NIF is duplicated
            }
          } else {
            // NIF does not exist in the database
            observer.next(null);
          }
          observer.complete();
        },
        error => {
          // Handle API error (e.g., network issue)
          observer.next(null); // Return null to not block the form
          observer.complete();
        }
      );
    });
  };
}

export function validacionCentroEmpleado(predicate:any, empresas: EmpresasModel[]): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {
    const value = control.value;
    const codigoEmpresaValue = predicate().controls['empresa']?.value?.split('-')[0];
    if(codigoEmpresaValue){
      let numeroCentros = empresas.find(x=>x.codigoEmpresa==codigoEmpresaValue).centros?.length;
      if(numeroCentros>0 && (value==''||value==null)) return {centroNecesario:true}
      else return null
    } else return null


  }
}

  // getEmpleados(filtrosEmpleados: FiltroEmpleado[], pageNumber:number, orden?: OrdenColumna){
  //   this.datosEmpleadosService.getEmpleados(filtrosEmpleados, pageNumber, orden).subscribe(
  //     next => {
  //       this.empleados = next;
  //     },
  //     error => {
  //       console.error();
  //     }
  //   )
  // }
